import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Home from './Home';
import Order from './Order';
import Navbars from './Navbars';
import CartContextProvider from './context/CardContext';
// import CardContext from './context/CardContext';
import CartContext from './context/CartContext';
import { Route, Redirect, Switch } from "react-router-dom";

const App = () => {

  return <>
    <CartContext>
      <CartContextProvider>
        <Navbars />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/order" component={Order} />
          <Redirect to="/" />
        </Switch>
      </CartContextProvider>
    </CartContext>
  </>;
};
export default App;